import { render, staticRenderFns } from "./WatTalksTopics.vue?vue&type=template&id=7721d81e&"
import script from "./WatTalksTopics.vue?vue&type=script&lang=js&"
export * from "./WatTalksTopics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports